/**
 * @wharfkit/transact-plugin-cosigner v0.3.4
 * https://github.com/wharfkit/transact-plugin-cosigner
 *
 * @license
 * Copyright (c) 2021 FFF00 Agents AB & Greymass Inc. All Rights Reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 * 
 *  1. Redistribution of source code must retain the above copyright notice, this
 *     list of conditions and the following disclaimer.
 * 
 *  2. Redistribution in binary form must reproduce the above copyright notice,
 *     this list of conditions and the following disclaimer in the documentation
 *     and/or other materials provided with the distribution.
 * 
 *  3. Neither the name of the copyright holder nor the names of its contributors
 *     may be used to endorse or promote products derived from this software without
 *     specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
 * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 * 
 * YOU ACKNOWLEDGE THAT THIS SOFTWARE IS NOT DESIGNED, LICENSED OR INTENDED FOR USE
 * IN THE DESIGN, CONSTRUCTION, OPERATION OR MAINTENANCE OF ANY MILITARY FACILITY.
 */
import { Struct, AbstractTransactPlugin, Name, PrivateKey, TransactHookTypes, Action, prependAction } from '@wharfkit/session';

class noop extends Struct {
}
noop.abiName = 'noop';
noop.abiFields = [];
class TransactPluginCosigner extends AbstractTransactPlugin {
    constructor(options) {
        super();
        this.id = 'transact-plugin-cosigner';
        this.contract = Name.from('greymassnoop');
        this.action = Name.from('noop');
        this.actor = Name.from(options.actor);
        this.permission = Name.from(options.permission);
        this.privateKey = PrivateKey.from(options.privateKey);
        if (options.contract) {
            this.contract = Name.from(options.contract);
        }
        if (options.action) {
            this.action = Name.from(options.action);
        }
    }
    register(context) {
        context.addHook(TransactHookTypes.beforeSign, async (request, context) => {
            // Modify request data to prepend noop action
            const modifiedRequest = await this.prependAction(request);
            // Sign Transaction
            const resolved = await context.resolve(modifiedRequest);
            const signature = this.privateKey.signDigest(resolved.transaction.signingDigest(request.getChainId()));
            // Create a new request that is a 'Transaction' and not an 'Action[]' array.
            const newRequest = await context.createRequest({
                transaction: resolved.transaction,
            });
            // Return modified request and new signature
            return {
                request: newRequest,
                signatures: [signature],
            };
        });
    }
    async prependAction(request) {
        // Create noop action to assume resource costs
        const newAction = Action.from({
            account: this.contract,
            name: this.action,
            authorization: [
                {
                    actor: this.actor,
                    permission: this.permission,
                },
            ],
            data: noop.from({}),
        });
        // Prepend this action to the request
        const newRequest = prependAction(request, newAction);
        // Return the modified request
        return newRequest;
    }
}

export { TransactPluginCosigner };
//# sourceMappingURL=transact-plugin-cosigner.m.js.map
